export default {
    computed: {
        defaultActive() {
            return this.$route.fullPath
        },
        baseRoute() {
            const { appId, workspaceId } = this.$route.params
            return `/app/${appId}/workspace/${workspaceId}`
        },
        isTenant() {
            return this.$store.state.modeling.app.isTenant
        },
    },
}
